<template>
	<div :class="hideCompany ? '' : 'footer'">
		<div class="container">
			<div class="footer-container row">
				<div class="col-md-12 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-between">
					<div class="col-md-6 mt-3 ps-1 pe-2 d-flex" v-if="!hideCompany">
						<span class="footer-content">© Powered By Secure365 Nextgen Solutions Sdn Bhd</span>
					</div>
					
					<div :class="hideCompany ? 'col-md-12' : 'col-md-6'" class="mt-3 ps-1 pe-2 d-flex justify-content-end">
						<span class="footer-content" style="color: darkgrey;">{{ "Version " + version + " @ " + date }} </span>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<ScrollTop target="window" :threshold="80" icon="pi pi-arrow-up" />
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { version, date } from "../../package.json";

	export default defineComponent({
		data() {
			return {
				version: version,
				date: date,
			};
		},
		props: {
			hideCompany: {
				type: Boolean,
				required: false
			},
		}
	});
</script>